



























































import {Component, Vue, Watch} from "vue-property-decorator";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {ReceiptExpensesType, ExpensePaymentType, ReceiptExpensesPickingListTargetType} from "@/enums/type";
import {cloneDeep, difference} from "lodash";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import {ExpensePostOfficeStore} from "@/modules/receiptsexpenses/expensepostoffice/store";
import {DebtPostOffice} from "@/interfaces/entity";
import {union} from "lodash";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {ExpensePostOfficeParams} from "@/modules/receiptsexpenses/expensepostoffice/params";
import ExpenseDebtPostOfficeTable
    from "@/modules/receiptsexpenses/expensepostoffice/Form/components/ExpenseDebtPostOfficeTable/index.vue";
import ConfirmReceiptExpense from "@/modules/receiptsexpenses/shared/components/ConfirmReceiptExpense/index.vue";
import {PostOfficeStore} from "@/modules/postoffices/store";
import PrintReceiptExpense from "@/modules/receiptsexpenses/shared/components/PrintReceiptExpense/index.vue";
import {getPublicPath} from "@/shared/services/helper/utils";
import ExpensePostOfficePickingListPrint from "@/modules/receiptsexpenses/expensepostoffice/shared/Print/index.vue";
import {ExpenseCustomerStore} from "@/modules/receiptsexpenses/expensecustomer/store";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

const form = {
    paymentType: undefined,
    debtIds: [],
    postOfficeRowGuid: undefined,
    type: ReceiptExpensesType.PickingListPay,
    note: undefined,
    bankAccount: undefined
};

@Component({
    name: "ExpensePostOfficeForm",
    components: {
        AInputBarCode,
        ExpensePostOfficePickingListPrint,
        PrintReceiptExpense,
        ConfirmReceiptExpense,
        ExpenseDebtPostOfficeTable, PostOfficeSelector, LadingPaymentTypeLabel, EnumSelector, EmployeeSelector
    }
})
export default class extends Vue {
    ExpensePaymentType = ExpensePaymentType;
    form = cloneDeep(form);
    ladingCode = "";
    selectedIds: number[] = [];
    isSaving = false;
    visibleConfirm = false;

    expensePickingListId = null as any;
    debts = [];
    printObj = {
        id: "expense-post-office-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    }

    created() {
        ExpensePostOfficeStore.clearCreditPostOfficeStore();
    }

    @Watch("form.postOfficeRowGuid")
    onChangePostOfficeRowGuid(val: any) {
        this.form.debtIds = [];
        if (!val) return;
        ExpensePostOfficeStore.listCreditPostOffice({
            ...new ExpensePostOfficeParams(),
            isPay: 1,
            postOfficeRowGuid: val,
            limit: 2000
        });
    }

    onChangeLadingCode(evt: any) {
        const val = evt?.target?.value;
        const debtIds: number[] = this.expensePostOffices
            .filter((credit: DebtPostOffice) => credit.billLading?.ladingCode === val)
            .map((credit: DebtPostOffice) => credit.id);
        this.form.debtIds = union(this.form.debtIds, debtIds) as any;
        setTimeout(() => this.ladingCode = "", 500);
    }

    get expensePostOffices() {
        return ExpensePostOfficeStore.ids.map((id: number) => ExpensePostOfficeStore.data[id]);
    }

    get dataConfirm() {
        const debts = this.form.debtIds.map((id: number) => ExpensePostOfficeStore.data[id]);
        const target = {
            type: ReceiptExpensesPickingListTargetType.PostOffice,
            name: this.form.postOfficeRowGuid ? PostOfficeStore.data[this.form.postOfficeRowGuid as any]?.name : ''
        }
        return {
            debts,
            target,
            isExpense: true,
        }
    }

    onSelectedIdsChange(selectedIds: any) {
        this.form.debtIds = selectedIds;
    }

    async onSave() {
        try {
            if (!this.isValidForm()) return;
            this.isSaving = true;
            const data = await ExpensePostOfficeStore.expensePostOffice(this.form);
            this.expensePickingListId = data.id;
            this.$message.success("Trả tiền bưu cục thành công");
            (this.$refs.printReceiptExpense as any).$el.click();
            this.refresh();
        } catch (e) {
            console.log(e);
            this.$message.error(e?.response?.data?.message || 'Đã xảy ra lỗi');
        }
        this.isSaving = false;
        this.visibleConfirm = false;
    }

    confirm() {
        if (!this.isValidForm()) return;
        this.visibleConfirm = true;
    }

    isValidForm() {
        if (!this.form.postOfficeRowGuid) {
            this.$message.error("Vui lòng chọn bưu cục");
            return false;
        }
        if (!this.form.debtIds.length) {
            this.$message.error("Vui lòng quét mã vận đơn để thu");
            return false;
        }
        if (!this.form.paymentType) {
            this.$message.error("Vui lòng chọn hình thức thanh toán");
            return false;
        }
        return true;
    }

    refresh() {
        this.ladingCode = "";
        this.form = cloneDeep(form);
        ExpensePostOfficeStore.clearCreditPostOfficeStore();
    }

    acceptDebt() {
        const deletedDebtPostOfficeIds = difference(ExpensePostOfficeStore.ids, this.form.debtIds);
        ExpensePostOfficeStore.deleteCreditPostOfficeByIds(deletedDebtPostOfficeIds);
    }
}
